import React, { PropsWithChildren } from 'react'

import './CheckResultsTable.scss'

export const CheckResultsTable = ({ children }: PropsWithChildren<any>) => {
  return <div className='results-table'>{children}</div>
}
